import { HttpInterceptorFn } from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../services/loading.service';
import { inject } from '@angular/core';

const isOidcUrl = (url: string) =>
  url.includes('/oauth2/token') ||
  url.includes('/oauth2/authorize') ||
  url.includes('/.well-known/openid-configuration') ||
  url.includes('/.well-known/jwks.json');

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {

  if (isOidcUrl(req.url)) {
    // ⛔️ No muestres loader ni toques nada para llamadas OIDC
    return next(req);
  }
  const loadingService = inject(LoadingService);

  loadingService.show();

  return next(req).pipe(finalize(() => loadingService.hide()));
};
